import React, { useState } from 'react'

import { clearFilters } from 'slices/filters'

import { Card, SimpleGrid } from '@driftt/dds'

import { useAppDispatch } from 'hooks/useRedux'
import useSavedFilterEditModal from 'hooks/useSavedFilterEditModal'
import useSavedFilters, { INACTIVE_FILTER } from 'hooks/useSavedFilters'
import AccountsPage from 'pages/AccountsPage'
import { FilterPage } from 'utils/filters'

import SavedFiltersSidebar from '../SavedFiltersSidebar'

export interface EngagementTabProps {}

const EngagementTab = ({ access }: { access: any; sessionMetrics: any }) => {
  const [toastText, setToastText] = useState<string | undefined>()
  const dispatch = useAppDispatch()
  const onClearFilterGroups = (page: FilterPage) => dispatch(clearFilters({ page }))

  const onClearFilters = () => {
    updateActiveFilterId(INACTIVE_FILTER)
    onClearFilterGroups(FilterPage.ACTIVITIES)
    onClearFilterGroups(FilterPage.ACCOUNTS)
  }
  const { activeSavedFilter, updateActiveFilterId } = useSavedFilters(setToastText)

  const { onOpenEditModal } = useSavedFilterEditModal()

  return (
    <SimpleGrid
      columns={2}
      gap={4}
      css={{
        height: '100%',
        gridTemplateColumns: '212px 1fr',
        gridTemplateRows: '100% calc(100% - $8)'
      }}>
      <SavedFiltersSidebar setToastText={setToastText} toastText={toastText} accountsPage />
      <Card
        css={{
          height: 'calc(100% - $8)',
          marginTop: '$4',
          '& .table-body-list': {
            height: 'calc(100%) !important'
          }
        }}>
        <AccountsPage
          access={access}
          onClear={onClearFilters}
          onOpenEditModal={onOpenEditModal}
          activeFilterId={activeSavedFilter?.id || INACTIVE_FILTER}
          onFilterChange={() => updateActiveFilterId(INACTIVE_FILTER)}
        />
      </Card>
    </SimpleGrid>
  )
}

export default EngagementTab
